import React from "react"
import PropTypes from "prop-types"

export const ValidationRulesPropType = PropTypes.shape({
  type: PropTypes.object,
  name: PropTypes.object
})

export const ValidationMessagePropType = PropTypes.shape({
  general: PropTypes.object,
  type: PropTypes.object,
  name: PropTypes.object
})

const propTypesFromParentToChild = {
  rules: ValidationRulesPropType,
  messages: ValidationMessagePropType
}

export default class FormProvider extends React.Component {
  static propTypes = propTypesFromParentToChild

  static defaultProps = {
    messages: {}
  }

  static childContextTypes = propTypesFromParentToChild

  getChildContext() {
    const { rules, messages } = this.props
    return {
      rules,
      messages
    }
  }

  render() {
    return this.props.children
  }
}
